import { useRef, useLayoutEffect } from 'react'

import { QuartarDataType } from '~/curriculum/types/curriculum.types'

import { useAppDispatch } from '~/redux/hooks'

import { setSelectedSubdivisionActionCreator } from '../slice/curriculum.slice'

interface Props {
  quarterList: QuartarDataType[]
  selectedSubdivision: number
  gradeLevel: number
}

export default function QuarterToggle({ quarterList, selectedSubdivision, gradeLevel }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)
  const sliderRef = useRef<HTMLDivElement>(null)
  const itemRefs = useRef<Array<HTMLButtonElement | null>>([])
  const dispatch = useAppDispatch()

  useLayoutEffect(() => {
    const selectedEl = itemRefs.current[selectedSubdivision]
    const sliderEl = sliderRef.current

    if (selectedEl && sliderEl && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect()
      const itemRect = selectedEl.getBoundingClientRect()

      sliderEl.style.width = `${itemRect.width}px`
      sliderEl.style.height = `${itemRect.height}px`
      sliderEl.style.left = `${itemRect.left - containerRect.left}px`
    }
  }, [selectedSubdivision, quarterList])

  return (
    <div className="flex justify-center">
      <div
        className="relative bg-white w-74 md:w-83 h-14 rounded-4 mb-6 flex justify-between items-center px-2"
        ref={containerRef}
      >
        <div className="absolute rounded bg-orange transition-all duration-300 z-0" ref={sliderRef} />

        {quarterList.map((quarter, index) => (
          <button
            className="relative h-3/4 z-10 flex-1 my-2 flex text-purple text-xxs font-bold md:text-xs items-center justify-center gap-x-2 p-1 cursor-pointer bg-transparent border-none focus:outline-none max-h-13"
            key={quarter.subdivisionLabel}
            onClick={() => dispatch(setSelectedSubdivisionActionCreator({ gradeLevel, index }))}
            ref={(el) => {
              itemRefs.current[index] = el
            }}
            type="button"
          >
            <h1 className="font-medium text-sm text-center leading-5 ">{quarter.subdivisionLabel}</h1>
          </button>
        ))}
      </div>
    </div>
  )
}
